import { M, n, O, pipe, RA, RR } from '@packages/prelude'
import * as domain from '@packages/domain'

type Field = domain.Meta.Fields.PersonalizationField.Type

// A field contributes its surcharge only when filled (Some); the format field contributes the
// selected choice's surcharge. Sum of the Somes = the add-on total the cart line will carry.
const contribution =
  (selection: RR.ReadonlyRecord<string, string>) =>
  (field: Field): O.Option<number> =>
    pipe(
      RR.lookup(field.id, selection),
      O.filter(v => v !== ''),
      O.chain(value =>
        domain.Meta.Fields.PersonalizationField.ADT.is.format(field)
          ? pipe(
              field.choices,
              RA.findFirst(c => c.id === value),
              O.map(c => c.surcharge)
            )
          : O.some(field.surcharge)
      )
    )

export const addonTotal = (fields: ReadonlyArray<Field>, selection: RR.ReadonlyRecord<string, string>): number =>
  pipe(fields, RA.filterMap(contribution(selection)), M.concatAll(n.MonoidSum))
